__turbopack_context__.v({
  "footer": "KV5Plq_footer",
  "main": "KV5Plq_main",
  "max-width-container": "KV5Plq_max-width-container",
  "page-container": "KV5Plq_page-container",
});
